"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isProduction = function (domain) { return !domain.match(/localhost|test|0\.0\.0\.0|\.lh/); };
exports.default = isProduction;
//# sourceMappingURL=isProduction.js.map